import dayjs from 'dayjs';
import {AdminDesignManagement} from "../admin-design-management.type";
import DesignProps = AdminDesignManagement.DesignProps;

export const initialDesignProps: DesignProps = {
    isGrayscale: false,
    backgroundColor: 'blue',
    fontSize: 16,
    startDate: dayjs(),
    endDate: dayjs().add(1, 'day'),
};

export const RegionMap = {
    1: 'blocks',
    2: 'search',
    3: 'main',
};
